"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateEnquiryStatusResponseDataDtoStatusEnum = void 0;
exports.instanceOfUpdateEnquiryStatusResponseDataDto = instanceOfUpdateEnquiryStatusResponseDataDto;
exports.UpdateEnquiryStatusResponseDataDtoFromJSON = UpdateEnquiryStatusResponseDataDtoFromJSON;
exports.UpdateEnquiryStatusResponseDataDtoFromJSONTyped = UpdateEnquiryStatusResponseDataDtoFromJSONTyped;
exports.UpdateEnquiryStatusResponseDataDtoToJSON = UpdateEnquiryStatusResponseDataDtoToJSON;
exports.UpdateEnquiryStatusResponseDataDtoToJSONTyped = UpdateEnquiryStatusResponseDataDtoToJSONTyped;
/**
 * @export
 */
exports.UpdateEnquiryStatusResponseDataDtoStatusEnum = {
    InProgress: 'in_progress',
    Open: 'open',
    Resolved: 'resolved'
};
/**
 * Check if a given object implements the UpdateEnquiryStatusResponseDataDto interface.
 */
function instanceOfUpdateEnquiryStatusResponseDataDto(value) {
    if (!('enquiryId' in value) || value['enquiryId'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function UpdateEnquiryStatusResponseDataDtoFromJSON(json) {
    return UpdateEnquiryStatusResponseDataDtoFromJSONTyped(json, false);
}
function UpdateEnquiryStatusResponseDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'enquiryId': json['enquiryId'],
        'status': json['status'],
    };
}
function UpdateEnquiryStatusResponseDataDtoToJSON(json) {
    return UpdateEnquiryStatusResponseDataDtoToJSONTyped(json, false);
}
function UpdateEnquiryStatusResponseDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'enquiryId': value['enquiryId'],
        'status': value['status'],
    };
}
